module.exports = __webpack_public_path__ + "img/video.bad80396.png";